import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const tokenHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: options([
      { value: 'Created', name: 'Created' },
      { value: 'Activated', name: 'Activated' },
      { value: 'Advanced', name: 'Advanced' },
      { value: 'Moved', name: 'Moved' },
      { value: 'Migrated', name: 'Migrated' },
      { value: 'Canceled By Migration', name: 'Canceled By Migration' },
      {
        value: 'Canceled By Loop Completion',
        name: 'Canceled By Loop Completion',
      },
      { value: 'Completed', name: 'Completed' },
      { value: 'Error Occurred', name: 'Error Occurred' },
      { value: 'Script Executed', name: 'Script Executed' },
      { value: 'Before Create Executed', name: 'Before Create Executed' },
      { value: 'After Create Executed', name: 'After Create Executed' },
      { value: 'Before Complete Executed', name: 'Before Complete Executed' },
      { value: 'After Complete Executed', name: 'After Complete Executed' },
    ]).describe('What happened to the token'),

    activityId: z
      .string()
      .nullable()
      .optional()
      .describe('The activity where this event occurred'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    token: belongsTo('Token'),

    tenant: references('Tenant'),
  })
  .describe("Records each significant event in a token's lifecycle")
  .as('TokenHistory');

export { tokenHistory as tokenHistorySchema };
